import http from '@/http';

export default {
  namespaced: true,

  state: {
    token: null,
    user: {},
    profile: {},
  },
  getters: {
    loggedIn(state) {
      return !!(state.user && state.user.email);
    },
  },
  mutations: {
    setToken(state, { token }) {
      if (token) {
        localStorage.neuralikeToken = token;
        http.defaults.headers.common.Authorization = `Token ${token}`;
      } else {
        delete localStorage.neuralikeToken;
        delete http.defaults.headers.common.Authorization;
      }
      state.token = token;
    },
    setUser(state, { user }) {
      state.user = user;
    },
  },
  actions: {
    async initializeUser({ commit, dispatch }) {
      commit('setToken', { token: localStorage.neuralikeToken });
      await dispatch('fetchUser');
    },
    async registerUser({ dispatch }, {
      email, firstName, lastName, password,
    }) {
      try {
        await http.request({
          url: '/auth/users/',
          method: 'post',
          data: {
            username: email,
            email,
            password,
          },
        });
      } catch (error) {
        if (!error.response || error.response.status !== 400) {
          throw error;
        }
        const { data } = error.response;
        data.email = data.username;
        return data;
      }

      await dispatch('login', { email, password });

      try {
        await dispatch('profile/setProfileData', { firstName, lastName }, { root: true });
      } catch (error) {
        if (!error.response || error.response.status !== 400) {
          throw error;
        }
        const { data } = error.response;
        return data;
      }
      return null;
    },
    async login({ commit, dispatch }, { email, password }) {
      const resp = await http.request({
        url: '/auth/token/login/',
        method: 'post',
        data: {
          username: email,
          password,
        },
        headers: {
          Authorization: '',
        },
      });
      const token = resp.data.auth_token;
      commit('setToken', { token });
      await dispatch('fetchUser');
    },
    async logout({ commit }) {
      await http.request({
        url: '/auth/token/logout/',
        method: 'post',
      });
      commit('setToken', { token: null });
      commit('setUser', { user: null });
    },
    async fetchUser({ commit, dispatch }) {
      const resp = await http.request({
        url: '/auth/users/me/',
        method: 'get',
      });
      const user = resp.data;
      commit('setUser', { user });

      dispatch('profile/getProfileData', {}, { root: true });
    },
  },
};
